const questions = document.querySelectorAll('.help-list .question');

// 为每个问题元素添加点击事件监听器
questions.forEach(question => {
    question.addEventListener('click', function() {
        // 找到当前问题元素后面的第一个答案元素
        const answer = this.nextElementSibling;
        
        // 切换答案的显示状态
        if (answer.style.display === 'none') {
            answer.style.display = 'block';
        } else {
            answer.style.display = 'none';
        }
    });
});